import { apiMethodsConst } from '~/services/methods';
import { IDSOReducerState, TDSOAction } from './interface';

export const initialState: IDSOReducerState = {
  office: null,
};

export default (state: IDSOReducerState = initialState, action: TDSOAction): IDSOReducerState => {
  switch (action.type) {
    case 'SELECT_OFFICE_SUCCESS':
      return {
        ...state,
        office: null,
      };

    case apiMethodsConst.GET_DSO_OFFICE_BY_ID_REQUEST: {
      return {
        ...state,
        office: action.payload,
      };
    }

    default: {
      return { ...state };
    }
  }
};
